import moment from "moment-timezone";

export function makeUtcDate(date) {
    return moment.utc(date).tz("Europe/Copenhagen");
}
